(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["final-six-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    const boot = () => {
      const config = document.querySelector('[data-final-six-runtime]');
      if (!config) return;

      const deadline = Number(config.dataset.deadline);
      const collectionHandle = config.dataset.collectionHandle;
      const messages = {
        zero: config.dataset.cartZero,
        one: config.dataset.cartOne,
        two: config.dataset.cartTwo,
        three: config.dataset.cartThree,
      };
      let cartTimer;

    const isActive = (now = Date.now()) => now <= deadline;

    const getCartMessage = (quantity) => {
      if (quantity >= 3) return messages.three;
      if (quantity === 2) return messages.two;
      if (quantity === 1) return messages.one;
      return messages.zero;
    };

    const expireCampaign = () => {
      document.querySelectorAll('[data-final-six-campaign]').forEach((element) => {
        element.hidden = true;
      });
      document.body.classList.remove('final-six-collection-page');
      document.body.classList.remove('final-six-product-page');
    };

    const decorateCollection = () => {
      const marker = document.querySelector(`[data-final-six-collection="${collectionHandle}"]`);
      if (!marker) return;
      document.body.classList.add('final-six-collection-page');
      document.querySelectorAll('#main-collection-product-grid .halo-productBadges').forEach((badge) => {
        if (badge.textContent.trim().toLowerCase() === 'sale') {
          badge.textContent = marker.dataset.badgeText;
        }
      });
    };

    const decorateProduct = () => {
      if (document.querySelector('[data-final-six-product]')) {
        document.body.classList.add('final-six-product-page');
      }
    };

    const cartUrl = () => {
      const base = window.routes?.cart_url || '/cart';
      return `${base.replace(/\/$/, '')}.js`;
    };

    const updateCartMessage = async () => {
      const mount = document.querySelector('[data-final-six-cart-message]');
      if (!mount || !isActive()) return;

      try {
        const response = await fetch(cartUrl(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        const cart = await response.json();
        mount.textContent = getCartMessage(Number(cart.item_count) || 0);
      } catch (_error) {
        mount.textContent = messages.zero;
      }

      mount.hidden = false;
    };

    const scheduleCartUpdate = () => {
      window.clearTimeout(cartTimer);
      cartTimer = window.setTimeout(updateCartMessage, 160);
    };

    const init = () => {
      if (!isActive()) {
        expireCampaign();
        return;
      }

      decorateCollection();
      decorateProduct();
      updateCartMessage();

      const cartDrawer = document.querySelector('#halo-cart-sidebar');
      if (cartDrawer) {
        new MutationObserver(scheduleCartUpdate).observe(cartDrawer, {
          childList: true,
          subtree: true,
        });
      }

      window.setInterval(() => {
        if (!isActive()) expireCampaign();
      }, 60000);
    };

      window.AmpertoFinalSix = {
        decorateCollection,
        getCartMessage,
        isActive,
        updateCartMessage,
      };
      config.dataset.ready = 'true';

      init();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
